import { CSPAnalysis } from "@/components/dashboard/csp-analysis";

export default function CSPPage() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          CSP Header Analysis
        </h1>
        <p className="text-gray-600 dark:text-gray-400">
          Analyze Content Security Policy headers and get security improvement recommendations
        </p>
      </div>
      
      <CSPAnalysis />
    </div>
  );
}